import { useSelector, useDispatch } from 'react-redux';
import { Grid, Box, Typography, useTheme, Button, CircularProgress } from '@mui/material';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import SelectAllIcon from '@mui/icons-material/SelectAll';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

import * as HrActions from '../../../../store/actions/hr.action';
import { getHrState } from '../../../../store/selector/hr.selector';

const styles = {
  statusGrid: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem',
    background: '#ffffff',
    border: '1px solid #00000030',
    borderRadius: '0.5rem',
    textTransform: 'none',
    '&:hover': {
      background: '#f7f7f7',
    },
    number: { fontSize: '2.5rem', fontWeight: '800' },
    text: { fontSize: '1rem', mr: '0.75rem' },
    width: '98%',
  },

  averageGridBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  averageGrid: {
    cursor: 'default',
    display: 'flex',
    textAlign: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    p: '1rem',
    border: '1px solid #00000030',
    borderRadius: '0.5rem',
    color: '#ffffff',
    number: { fontSize: '2.5rem', fontWeight: '800' },
    text: { fontSize: '1rem' },
    width: '93%',
    height: '90%',
  },
};

const DashboardApplicationStatus = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  /* eslint-disable camelcase */
  const {
    is_loading_dashboard_list,
    reports_query,
    dashboard_list: {
      ApplicationsReport: { counts },
    },
  } = useSelector(getHrState);

  const filterCount = (e: string) => {
    if (reports_query) {
      dispatch(
        HrActions.DashboardApplicationData({
          ...reports_query,
          department: '',
          month: '',
          province: '',
          reason: '',
          signatory: '',
          status: e,
          year: '',
        }),
      );
    }
  };

  return (
    <Grid container>
      <Grid
        item
        md={3}
        sm={6}
        xs={12}
        component={Button}
        disabled={counts.Completed === null && is_loading_dashboard_list ? true : false}
        onClick={() => {
          filterCount('finalized');
        }}
      >
        <Box sx={styles.statusGrid}>
          {counts.Completed !== null && !is_loading_dashboard_list ? (
            <Typography sx={styles.statusGrid.number}>{counts.Completed}</Typography>
          ) : (
            <CircularProgress color='primary' size={40} thickness={5} sx={{ mt: '0.75rem' }} />
          )}

          <Box sx={{ display: 'flex', mt: '1rem' }}>
            <Typography sx={styles.statusGrid.text}>Completed</Typography>
            <TaskAltIcon sx={{ color: '#359D78' }} />
          </Box>
        </Box>
      </Grid>

      <Grid
        item
        md={3}
        sm={6}
        xs={12}
        component={Button}
        disabled={counts.Pending === null && is_loading_dashboard_list ? true : false}
        onClick={() => {
          filterCount('approved');
        }}
      >
        <Box sx={styles.statusGrid}>
          {counts.Pending !== null && !is_loading_dashboard_list ? (
            <Typography sx={styles.statusGrid.number}>{counts.Pending}</Typography>
          ) : (
            <CircularProgress color='primary' size={40} thickness={5} sx={{ mt: '0.75rem' }} />
          )}

          <Box sx={{ display: 'flex', mt: '1rem' }}>
            <Typography sx={styles.statusGrid.text}>Pending</Typography>
            <PendingActionsIcon sx={{ color: '#F9AE2C' }} />
          </Box>
        </Box>
      </Grid>

      <Grid
        item
        md={3}
        sm={6}
        xs={12}
        component={Button}
        disabled={counts.Total === null && is_loading_dashboard_list ? true : false}
        onClick={() => {
          filterCount('');
        }}
      >
        <Box sx={styles.statusGrid}>
          {counts.Total !== null && !is_loading_dashboard_list ? (
            <Typography sx={styles.statusGrid.number}>{counts.Total}</Typography>
          ) : (
            <CircularProgress color='primary' size={40} thickness={5} sx={{ mt: '0.75rem' }} />
          )}

          <Box sx={{ display: 'flex', mt: '1rem' }}>
            <Typography sx={styles.statusGrid.text}>Total</Typography>
            <SelectAllIcon color='primary' />
          </Box>
        </Box>
      </Grid>

      <Grid item md={3} sm={6} xs={12} sx={styles.averageGridBox}>
        <Box sx={{ ...styles.averageGrid, background: theme.palette.primary.main }}>
          {counts.TAT !== null && !is_loading_dashboard_list ? (
            <Typography sx={styles.averageGrid.number}>{counts.TAT}</Typography>
          ) : (
            <CircularProgress size={40} thickness={5} sx={{ mt: '0.75rem', color: '#fff' }} />
          )}

          <Typography sx={styles.averageGrid.text}>Average Turnaround</Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DashboardApplicationStatus;
